<template>
    <div v-if="permission && permission.version === '5'" class="fluid page_content pg_mc_list">
        <div class="row page-heading pr-0">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon ic24-microCompetency"></span>
                <span class="module_type_name">Micro Competency Management</span>
            </div>
            <div class="col-4 submit btn-container text-right">

              <div class="pg_3x3_menu">
                <b-dropdown no-caret class="navigation-menu">
                  <template slot="button-content">
                    <span class="module_icon ic22-menu3x3">
                      <span class="sr-only">micro competency menu</span>
                    </span>
                  </template>
                  <div class="links new_menu">
                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">
                      <span class="lnk_txt">Delete</span>
                    </b-dropdown-item>
                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" :disabled="(selected.length === 0)" aria-label="Publish">
                      <span class="lnk_txt">Publish</span>
                    </b-dropdown-item>
                    <!--
                      <span class="tag archive" v-if="!microCompetency.published" title="Publish" v-b-tooltip.hover @click.prevent="showPublishConfirm(microCompetency)">Publish</span>
                    -->
                  </div>
                </b-dropdown>
              </div>

            </div>
        </div>

        <div class="course-management-section">
            <div class="page_subheading">
              <div class="course-list-left">
                <label id="mcTitle" class="head_txt module_type_name ace_sec_hd" role="heading" aria-label="micro competencies">
                  <b-form-select
                    v-model="currentGroup"
                    :options="groups"
                    class=""
                    value-field="name"
                    text-field="name"
                    disabled-field="notEnabled"
                    :title="currentGroup">
                  </b-form-select>
                </label>
                <span class="selected-count ace_sec_txt">{{ selected.length }} / {{ totalElements }}</span>
              </div>
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                  <option v-for="option in sizeOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                  <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
                  <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                </div>
                <div class="search-box-container">
                  <input type="text" class="input-search" v-model="name" placeholder="search by micro competency title" aria-label="search by title" @input="enableSearch" @keyup.enter="handleSearch">
                  <button type="button" class="btn btn_srh" @click="handleSearch" aria-label="search" :disabled="mcSearchBtnStatus">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="course-management-table-container">
                <table v-if="isDataLoaded" class="table b-table table-bordered border">
                    <thead class="thead-light text-center">
                        <tr>
                          <th class="first-column">
                            <label class="form-checkbox">
                              <input type="checkbox" v-model="selectAll" @click="select" :disabled="(microCompetencies.length === 0) || permission.systemPermission.readOnly" aria-label="select all mcs">
                              <i class="form-icon"></i>
                            </label>
                          </th>
                          <th class="second-column">Title</th>
                          <th class="third-column">Owner</th>
                          <th class="fourth-column">Folder</th>
                          <th class="fifth-column">Date Updated</th>
                          <th class="fifth-column">Tags</th>
                          <th class="last-column">Flags / Action</th>
                        </tr>
                    </thead>
                    <tbody v-if="microCompetencies.length > 0">
                        <tr v-for="microCompetency in microCompetencies">
                            <td class="first-column text-center">
                                <label class="form-checkbox">
                                    <input type="checkbox" :value="microCompetency.uuid" v-model="selected" :disabled="(microCompetencies.length === 0) || permission.systemPermission.readOnly" aria-label="select mc">
                                    <i class="form-icon"></i>
                                </label>
                            </td>
                            <td class="second-column col_title">
                                <a href="javascript://" @click="goToMC(microCompetency.uuid)">{{ microCompetency.title }}</a>
                            </td>
                            <td class="third-column col_owner">{{ microCompetency.ownerName }}</td>
                            <td class="fourth-column col_lib">{{ microCompetency.owningLibraryName }}</td>
                            <td class="fifth-column col_date">{{ getFormattedDateTime(microCompetency.lastUpdatedTime) }}</td>
                            <td class="fifth-column col_date">
                              <template v-for="(values, key, i) in microCompetency.appliedTagMap" class="tags_container">
                              <div class="tags_row">
                                <span class="tag type" v-for="(tag, j) in values">
                                  <span class="tag_name" :title="tag.name" v-b-tooltip.hover>{{tag.name}}</span>
                                </span>
                              </div>
                              </template>
                            </td>

                            <td class="last-column action_menu_container">
                              <div class="tags_row">
                                <span class="tag">
                                  <span class="tag_name type" :title="getTypeLabel(microCompetency.competencyType)" v-b-tooltip.hover> {{microCompetency.competencyType}} </span>
                                </span>
                                <span class="tag" v-if="microCompetency.published">
                                  <span class="tag_name archive" title="Published" v-b-tooltip.hover > Published </span>
                                </span>
                                <span class="tag" v-else>
                                  <span class="tag_name archive" title="Draft" v-b-tooltip.hover> Draft </span>
                                </span>
                              </div>

                              <div class="action">
                                <b-dropdown no-caret class="navigation-menu">
                                  <template slot="button-content">
                                    <span class="module_icon ic9-iconMore-0005 ic_more">
                                      <span class="sr-only">action</span>
                                    </span>
                                  </template>
                                  <div class="links new_menu">
                                    <b-dropdown-item class="lnk_menu lnk_menu_footer" role="link" @click.prevent="showPublishConfirm(microCompetency)" aria-label="Publish">
                                      <span class="lnk_txt">Publish</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item class="lnk_menu lnk_menu_footer" @click.prevent="makeCopy(microCompetency)" role="link" aria-label="Make a Copy">
                                      <span class="lnk_txt">Make a Copy</span>
                                    </b-dropdown-item>
                                    <!--
                                      <span class="tag archive" v-if="!microCompetency.published" title="Publish" v-b-tooltip.hover @click.prevent="showPublishConfirm(microCompetency)">Publish</span>
                                    -->
                                  </div>
                                </b-dropdown>
                              </div>
                            </td>

                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                        	<td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div>
          <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <h6>Are you sure you want delete these ({{ selected.length }}) micro competencies?</h6>
            </div>
    				<div slot="modal-header" class="header-section" style="padding: 10px 9px 6px 12px;">
    					<div class="popup-heading">Please Confirm!</div>
    					<button class="btn_close" aria-label="close" @click="cancelDelete">
                <span class="ic-close"></span>
              </button>
    				</div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
              <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-modal class="delete-folder-popup" ref="publishConfirmModal" no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <h6>Are you sure you want publish {{ mcToPublish.title }} Micro Competency?</h6>
            </div>
            <div slot="modal-header" class="header-section" style="padding: 10px 9px 6px 12px;">
              <div class="popup-heading">Please Confirm!</div>
              <button class="btn_close" aria-label="close" @click="cancelPublish">
                <span class="ic-close"></span>
              </button>
            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="publishOne" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
              <b-button @click="cancelPublish" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
            </div>
          </b-modal>
        </div>
        <div>
          <b-modal class="delete-folder-popup" ref="publishErrorModal" no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <h6>Micro Competency {{ mcToPublish.title }} Publish failed.</h6>
              <h6>{{ mcPublishError}}</h6>
            </div>
            <div slot="modal-header" class="header-section" style="padding: 10px 9px 6px 12px;">
              <div class="popup-heading">Validation Failed!</div>
               <button class="btn_close" aria-label="close" @click="publishErrorClose">
                <span class="ic-close"></span>
              </button>

            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="publishErrorClose" class="btn button-primary next float-right mr-2" aria-label="ok"> ok </b-button>
            </div>
          </b-modal>
        </div>
        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>

</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/css/course/courseList.min.css'
  export default {
    name: 'mc-list',
    data () {
      return {
        microCompetencies: [],
        currentGroup: "All Micro Competencies",
        groups: [{name:"All Micro Competencies"},{name:"Published Micro Competencies"}, {name:"Unpublished Micro Competencies"}],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        name: '',
        published: 'ALL',
        archive: 'false',
        archiveFlag: false,
        archiveOrUnarhive : 'archive',
        selected: [],
        selectAll: false,
        isDataLoaded: false,
        mcSearchBtnStatus: true,
        mcToPublish : {},
        mcPublishError: '',
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadMicrocompetenciesList()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'loadMicrocompetencies',
        'deleteMicroCompetencies',
        'publishMicroCompetencies',
        'publishMicroCompetency',
        'loadPermission',
        'createCopy'
      ]),
      computeGroupToShow (){
        let current = this.currentGroup
        this.published = 'ALL'

        if(current === 'All Micro Competencies'){
            this.published = 'ALL'
        }

        if(current === 'Published Micro Competencies'){
            this.published = 'true'
        }
        if(current === 'Unpublished Micro Competencies'){
            this.published = 'false'
        }
        this.loadMicrocompetenciesList()
      },
      loadMicrocompetenciesList () {
        this.$refs.loadingModal.show()
        this.loadMicrocompetencies({page: this.page, count: this.pageSize, title: this.name, published: this.published}).then(result => {
          this.microCompetencies = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.$refs.loadingModal.hide()
          this.isDataLoaded = true
          if (this.selectAll) {
            this.selected = []
            this.selectAll = false
          }
          this.$refs.loadingModal.hide()
        })
      },

      goToMC (uuid) {
        return this.$router.push({name: 'microCompetencyEdit', params: { uuid: uuid }})
      },

      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.microCompetencies) {
            this.selected.push(this.microCompetencies[i].uuid)
          }
        }
      },

      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.deleteMicroCompetencies(this.selected).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Micro Competencies deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Micro Competencies not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Course deletion failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadMicrocompetenciesList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      },
      publishErrorClose(){
      	 this.$refs.publishErrorModal.hide()
      },
      showPublishConfirm (mcToPub){
      	  this.mcToPublish = mcToPub
          this.$refs.publishConfirmModal.show()
      },
      makeCopy(source){
          this.createCopy(source.uuid).then(res => {
            if(res.uuid){
              setTimeout(() => {
                this.loadMicrocompetenciesList()
              }, 1000)
              this.showMessage('Successfully created copy of '+source.title)
            }else{
              this.showMessage('Error created copy of '+source.title)
            }
          })
      },
      getTypeLabel(type){
      var competencyTypes = [{id:'PBL', displayName:"Problem Based Learning"},{id:'CBL', displayName:"Competency Based Learning"}]
      for(var j=0;j<competencyTypes.length;j++){
          if(type===competencyTypes[j].id){
            return competencyTypes[j].displayName
          }
      }
      return ""
    },
      publishOne(){
        this.$refs.publishConfirmModal.hide()
        this.publishMicroCompetency(this.mcToPublish.uuid).then(res => {
          if (res) {
          	if(res.indexOf('Published Succussfully')!=-1){
          		this.showMessage(res, 'success')
		          setTimeout(() => {
		            this.loadMicrocompetenciesList()
		          }, 1000)

          	} else{
          		this.mcPublishError = res
          		this.$refs.publishErrorModal.show()
          	}
          } else {
          	this.showMessage('Micro Competency publish failed due to a network issue.', 'error')
          }

        })
        this.selected = []
        this.selectAll = false
      },

    showMessage (message, mType) {
      this.$notify({
        group: 'notify',
        type: mType,
        title: '',
        text: message
      })
    },

      publishSelected () {
        this.$refs.publishConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.publishMicroCompetencies({items:this.selected, flag:true}).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Micro Competencies ' +  ' published successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Micro Competencies not published due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Micro Competencies archive failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadMicrocompetenciesList()
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },

      cancelPublish () {
        this.$refs.publishConfirmModal.hide()
        this.selected = []
        this.mcToPublish = {}
        this.selectAll = false
      },
      enableSearch () {
        if (this.name.length > 0) {
          this.mcSearchBtnStatus = false;
        } else {
          this.mcSearchBtnStatus = true;
        }
      },
      handleSearch() {
        this.loadMicrocompetenciesList()
      },
      handleSearchEmpty(){
      		this.name = ''
      		this.loadMicrocompetenciesList()
      },
      resetPage () {
        this.page = 0
        this.loadMicrocompetenciesList()
      },

      prev () {
        this.page -= 1
        this.loadMicrocompetenciesList()
      },

      next () {
        this.page += 1
        this.loadMicrocompetenciesList()
      },

      getFormattedDateTime (timeInMillis) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ' ' + amPm
        return str
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission,
        'institution': state => state.institution.institution
      })
    },
    watch: {
    currentGroup (newCurrentGroup) {
        this.computeGroupToShow()
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/microCompetency/components/MicroCompetencyList.vue